import * as React from 'react';

import { useQuery } from '@apollo/client/react';
import { useMsal } from '@azure/msal-react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Divider, Stack, useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useLocation, useNavigate } from 'react-router';

import MLLogo from '../../assets/ML-Logo.png';
import { GetUserDocument } from '../../gql/graphql';

import HelpMenu from './HelpMenu/HelpMenu';
import { Logo } from './Logo/Logo';
import { MobileMenuButton } from './MobileMenuButton/MobileMenuButton';
import { MobileMenuNavDrawer } from './MobileMenuNavDrawer/MobileMenuNavDrawer';
import { NavTabs } from './NavTabs/NavTabs';
import { UserMenu } from './UserMenu/UserMenu';

const pages = [
  { name: 'List', path: '/', icon: FormatListBulletedIcon },
  { name: 'Calendar', path: '/calendar', icon: CalendarMonthIcon },
];

function ResponsiveAppBar() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const { instance } = useMsal();
  const { data } = useQuery(GetUserDocument);
  const currentTab = pages.findIndex((page) => page.path === pathname);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [openDrawer, setOpenDrawer] = React.useState<boolean>(false);
  const [selected, setSelected] = React.useState(false);
  const [value, setValue] = React.useState(currentTab === -1 ? 0 : currentTab);

  const handleTabChange = async (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    await navigate(pages[newValue].path + search);
  };
  const handleTabChangeClick = (event: React.SyntheticEvent, newValue: number) => {
    void handleTabChange(event, newValue);
  };
  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setSelected(true);
    setAnchorElUser(event.currentTarget);
  };
  const handleClosePopover = () => {
    setSelected(false);
    setAnchorElUser(null);
  };
  const handleLogin = () => {
    instance
      .loginRedirect({
        scopes: ['User.Read'],
        prompt: 'select_account',
        redirectUri: '/',
      })
      .catch((e) => {
        console.error(e);
      });
  };
  const handleLogout = async () => {
    await instance.logoutRedirect({ postLogoutRedirectUri: '/' });
  };
  const handleLogoutClick = () => {
    void handleLogout();
  };
  const handleDrawerNavigate = (path: string) => {
    void navigate(path + search);
  };

  return (
    <AppBar position="static">
      <Toolbar variant="dense" disableGutters>
        <Logo src={MLLogo} alt="Morgan, Lewis & Bockius LLP Logo" />
        <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', md: 'flex' } }} />
        <NavTabs value={value} handleTabChange={handleTabChangeClick} pages={pages} />
        <MobileMenuButton setOpenDrawer={setOpenDrawer} />
        <MobileMenuNavDrawer
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          theme={theme}
          pages={pages}
          navigate={handleDrawerNavigate}
        />
        <Stack direction="row" spacing={1} sx={{ flexWrap: 'nowrap' }}>
          <HelpMenu />
          <UserMenu
            data={data}
            anchorElUser={anchorElUser}
            handleOpenPopover={handleOpenPopover}
            handleClosePopover={handleClosePopover}
            handleLogin={handleLogin}
            handleLogout={handleLogoutClick}
            selected={selected}
          />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;
